import Marquee from "react-fast-marquee";

const WORDS = [
  "Service",
  "Repair",
  "Detailing",
  "Ceramic",
  "Diagnostics",
  "Alignment",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee"
      className="border-y border-white/10 bg-[#050505] py-8 md:py-10"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-4xl font-black uppercase tracking-tight text-white md:px-12 md:text-6xl">
              {w}
            </span>
            <span className="text-3xl text-[var(--volt)] md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
